import R from 'ramda';
import { createReducer } from 'ha/myredux/createReducer';
import { Kinds, PAGE_SIZE } from 'ha/pages/Inbox/constants';
import {
  load,
  favor,
  archive,
  toggleSidebar,
  toggleListingsGroup,
  removeFilters,
} from 'ha/pages/Inbox/actions';

const initialState = {
  initial: true,
  loading: false,
  bookings: [],
  listings: [],
  expandedListingsGroups: [],
  isSidebarVisible: false,
  pager: {
    total: 0,
    offset: 0,
    limit: PAGE_SIZE,
  },
  displayParams: {
    listing: null,
    state: Kinds.INBOX,
  },
};

function updateBookingField(id, key, value, bookings) {
  const booking = R.find(R.propEq('id', id))(bookings);

  return R.update(bookings.indexOf(booking), R.assoc(key, value, booking))(
    bookings,
  );
}

function updateBookingsKindData(key, inc, data) {
  const count = R.propOr(0, key, data);

  return R.assoc(key, inc ? R.inc(count) : R.dec(count), data);
}

export default createReducer(
  {
    [load.start]: state => ({
      ...state,
      displayParams: {
        ...state.displayParams,
      },
      loading: true,
    }),
    [load.done]: (state, payload) => ({
      ...state,
      initial: false,
      loading: false,
      bookings: payload.bookings,
      bookingsKindData: payload.kindData,
      listings: payload.listings,
      isSidebarVisible: false,
      displayParams: {
        ...state.displayParams,
        ...payload.params,
      },
      pager: {
        ...state.pager,
        total: payload.bookingsCount,
        offset: payload.params.offset,
        limit: initialState.pager.limit,
        quantity: initialState.pager.limit,
      },
    }),
    [load.error]: state => ({
      ...state,
      loading: false,
    }),
    [favor.done]: (state, { conversationID, flagStarred }) => ({
      ...state,
      bookings: updateBookingField(
        conversationID,
        'flagStarred',
        flagStarred,
        state.bookings,
      ),
      bookingsKindData: updateBookingsKindData(
        'flagStarred',
        flagStarred,
        state.bookingsKindData,
      ),
    }),
    [archive.done]: (state, { conversationID, flagArchived }) => ({
      ...state,
      bookings: updateBookingField(
        conversationID,
        'flagArchived',
        flagArchived,
        state.bookings,
      ),
      bookingsKindData: R.pipe(
        data => updateBookingsKindData('archived', flagArchived, data),
        data => updateBookingsKindData('inbox', !flagArchived, data),
      )(state.bookingsKindData),
    }),
    [toggleSidebar]: state => ({
      ...state,
      isSidebarVisible: !state.isSidebarVisible,
    }),
    [toggleListingsGroup]: (state, payload) => ({
      ...state,
      expandedListingsGroups: R.contains(payload, state.expandedListingsGroups)
        ? R.without(payload, state.expandedListingsGroups)
        : R.append(payload, state.expandedListingsGroups),
    }),
    [removeFilters]: state => ({
      ...state,
      displayParams: initialState.displayParams,
    }),
  },
  initialState,
);

export const getInitial = R.prop('initial');
export const getPager = R.prop('pager');
export const getListings = R.prop('listings');
export const getBookingsKindData = R.prop('bookingsKindData');
export const getExpandedListingsGroups = R.prop('expandedListingsGroups');
export const getBookings = R.prop('bookings');

export const getDisplayParams = R.prop('displayParams');
export const getCurrentKind = R.pipe(
  getDisplayParams,
  R.prop('state'),
);
export const getCurrentListing = R.pipe(
  getDisplayParams,
  R.prop('listingId'),
);
export const getCurrentListingObject = R.lift((listings, id) =>
  listings.find(({ id: entityId }) => entityId === parseInt(id, 10)),
)(getListings, getCurrentListing);
export const getCurrentQuery = R.pipe(
  getDisplayParams,
  R.prop('text'),
);
